import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ba-time-out',
  templateUrl: './time-out.component.html'
})
export class TimeOutComponent {
  constructor(
    public router: Router
  ) { }

  redirectToMainPage() {
    if (localStorage.getItem('loggedInUser')) {
      this.router.navigate(['/sales/locationItems']);
    } else {
      this.router.navigate(['login']);
    }
  }
}
